interface Props {
  error: unknown
  onRetry?: () => void
}

export function ErrorBanner({ error, onRetry }: Props) {
  const message = error instanceof Error ? error.message : String(error ?? "Unknown error")
  return (
    <div className="rounded border border-red-200 bg-red-50 p-4">
      <p className="font-semibold text-red-800">Couldn't load the sprint snapshot</p>
      <p className="mt-1 text-sm text-red-700">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-3 rounded bg-red-600 px-3 py-1 text-sm text-white hover:bg-red-700"
        >
          Try again
        </button>
      )}
      <p className="mt-3 text-[11px] text-red-700">
        If this persists, check the backend logs and confirm ADO_PAT is set and not expired.
      </p>
    </div>
  )
}
